var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "action-toolbar" }, [
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { title: _setup.TEXT.copy },
        on: { click: _setup.copyContent },
      },
      [
        _c("img", {
          staticClass: "action-icon",
          attrs: { src: _setup.ICON.copy, alt: _setup.TEXT.copy },
        }),
      ]
    ),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { title: _setup.TEXT.downloadTxt },
        on: { click: _setup.downloadContent },
      },
      [
        _c("img", {
          staticClass: "action-icon",
          attrs: { src: _setup.ICON.download, alt: _setup.TEXT.downloadTxt },
        }),
      ]
    ),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { title: _setup.TEXT.email },
        on: { click: _setup.emailContent },
      },
      [
        _c("img", {
          staticClass: "action-icon",
          attrs: { src: _setup.ICON.email, alt: _setup.TEXT.email },
        }),
      ]
    ),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { title: _setup.TEXT.print },
        on: { click: _setup.printContent },
      },
      [
        _c("img", {
          staticClass: "action-icon",
          attrs: { src: _setup.ICON.print, alt: _setup.TEXT.print },
        }),
      ]
    ),
    _c("div", { staticClass: "toolbar-separator" }),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { title: _setup.TEXT.like },
        on: { click: _setup.likeContent },
      },
      [
        _c("img", {
          staticClass: "action-icon",
          attrs: { src: _setup.ICON.like, alt: _setup.TEXT.like },
        }),
      ]
    ),
    _c(
      "button",
      {
        staticClass: "action-button",
        attrs: { title: _setup.TEXT.dislike },
        on: { click: _setup.dislikeContent },
      },
      [
        _c("img", {
          staticClass: "action-icon",
          attrs: { src: _setup.ICON.dislike, alt: _setup.TEXT.dislike },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }